var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSharp = function SvgSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99965 0.661438L5.75547 5.14979L0.644531 5.71767L4.56446 9.3576L2.6726 14.7494L7.99965 12.0859L13.3267 14.7494L11.4348 9.3576L15.3548 5.71767L10.2438 5.14979L7.99965 0.661438Z",
    fill: "currentcolor"
  })));
};
export default SvgSharp;